<template>
  <div class="plan-hosting">
    <div class="level-2">
      计划托管
      <div class="bulb-wrapper" @click="showPlanHosting = true">
        <el-image
          class="icon"
          :src="require('@/assets/images/simulation/icon_bulb.png')"
          fit="cover"
        ></el-image>
        <span class="bulb-text">了解详情</span>
      </div>
    </div>
    <el-radio-group v-model="form.planHosting" size="medium">
      <el-radio-button label="开启"></el-radio-button>
      <el-radio-button label="关闭"></el-radio-button>
    </el-radio-group>

    <div v-show="form.planHosting == '开启'">
      <p class="level-2">
        超成本自动暂停
        <el-popover placement="top" trigger="hover" width="303">
          <p style="font-size: 12px; line-height: 1.8">
            冷启动赔付结束后，如托管计划累计成本过高系统将自动关停。赔付周期内仍需关注成本变化
          </p>
          <i class="el-icon-question" slot="reference"></i>
        </el-popover>
      </p>
      <el-radio-group v-model="form.autoStop" size="medium">
        <el-radio-button label="开启"></el-radio-button>
        <el-radio-button label="关闭"></el-radio-button>
      </el-radio-group>
    </div>

    <tips-drawer
      :showPlanHosting="showPlanHosting"
      @onClose="showPlanHosting = false"
    />
  </div>
</template>

<script>
import tipsDrawer from "./tipsDrawer.vue";
export default {
  components: { tipsDrawer },
  props: {
    form: Object,
  },
  data() {
    return {
      showPlanHosting: false,
    };
  },
};
</script>

<style lang="less" scoped>
.plan-hosting {
  .level-2 {
    margin-top: 28px;
    margin-bottom: 12px;
    line-height: 20px;
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }
  .el-icon-question {
    color: #d3d3d3;
    font-size: 16px;
    vertical-align: -1px;
    cursor: pointer;
  }
  .bulb-wrapper {
    display: inline-block;
    margin-left: 5px;
    cursor: pointer;
    &:hover {
      .bulb-text {
        visibility: visible;
        opacity: 1;
      }
    }
    .icon {
      vertical-align: -5px;
    }
    .bulb-text {
      display: inline-block;
      padding-right: 8px;
      font-size: 12px;
      font-weight: 400;
      line-height: 26px;
      color: #ee8c10;
      height: 26px;
      border-radius: 19px;
      overflow: hidden;
      background: radial-gradient(
          42.91% 103.85% at 82.93% -23.08%,
          rgba(255, 126, 71, 0.15) 0,
          hsla(0, 0%, 100%, 0) 100%
        ),
        linear-gradient(
          268.85deg,
          #fef7d8 23.21%,
          rgba(254, 247, 216, 0) 99.01%
        );
      vertical-align: middle;
      transition: all 0.3s ease;
      visibility: hidden;
      opacity: 0;
    }
  }
  ::v-deep  .el-radio-group {
    .el-radio-button__inner {
      padding-left: 15px;
      padding-right: 15px;
      min-width: 100px;
      height: 34px;
      background: #f2f2f2;
      border: 1px solid transparent;
      color: #333;
      // border-radius: 4px;
      &:hover {
        background-color: #eff0fe;
      }
    }
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      color: #194ce5;
      border: 1px solid #194ce5;
      background-color: #fff;
      box-shadow: none;
    }
  }
}
</style>